import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { mapService } from '@/editor/components/googleMaps/google-map-service';
import {
  addPlace,
  removeAllPlaces,
  updatePlaceCenter,
  updatePlaceRadius,
} from '@/editor/store/reducers/adSet-step.slice';
import { SelectedPlace } from '@/editor/components/googleMaps/useAutocomplete';

export const useMapCircles = (selectedPlace: SelectedPlace | null, radiusAutoComplete: number) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedPlace) return;

    const circle = mapService.createCircle(
      selectedPlace.lat,
      selectedPlace.lng,
      radiusAutoComplete,
      selectedPlace.name,
      {
        onRadiusChange: (radius) => {
          dispatch(updatePlaceRadius({ address: selectedPlace.name, radius }));
        },
        onCenterChange: (center) => {
          dispatch(
            updatePlaceCenter({
              address: selectedPlace.name,
              center: {
                lng: center.lng(),
                lat: center.lat(),
              },
            })
          );
        },
      }
    );

    if (circle) {
      dispatch(
        addPlace({
          address: selectedPlace.name,
          center: { lat: selectedPlace.lat, lng: selectedPlace.lng },
          radius: radiusAutoComplete,
          countryCode: selectedPlace.countryCode,
        })
      );
    }

    return () => {};
  }, [selectedPlace]);

  const clearAllCircles = () => {
    dispatch(removeAllPlaces());
  };

  return { clearAllCircles };
};
